import { FetchApiPost } from "@/lib/utils/request";
import { LoginPayload, LoginResponse } from "@/types/auth";
import {
  saveTokens,
  clearTokens,
  setAuthSessionCookie,
  setupTokenRefresh,
  stopTokenRefresh,
} from "@/lib/utils/auth";
import apiClient from "@/lib/api/client";

export const login = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response = await FetchApiPost<LoginResponse>(
    "/user/auth/login/web",
    payload,
  );

  const data = response.data;

  if (!data) {
    throw new Error(response.message || "로그인 실패");
  }

  // Save tokens if available in response body
  if (data.accessToken && data.refreshToken) {
    // JWT session-based: save with expiry time
    saveTokens(
      data.accessToken,
      data.refreshToken,
      data.expiresIn, // expiresIn in seconds, will be converted to milliseconds
    );

    // Setup automatic token refresh
    setupTokenRefresh();
  } else if (data.accessToken) {
    // Only access token available
    saveTokens(data.accessToken, data.refreshToken || "", data.expiresIn);
    if (data.refreshToken) {
      setupTokenRefresh();
    }
  } else {
    // If tokens are not in response body, they might be in HTTP-only cookies set by server
    // Set a client-side authentication cookie to indicate successful login
    // Use userId as a session identifier to indicate authenticated state
    if (data.userId) {
      setAuthSessionCookie(String(data.userId));
    }
  }

  return data;
};

export const logout = async (): Promise<void> => {
  // Stop token refresh
  stopTokenRefresh();

  try {
    await apiClient.post(
      "/user/auth/logout/web",
      {},
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      },
    );
  } catch (error) {
    console.error("Logout error:", error);
    // Continue with clearing tokens even if API call fails
  }

  // Clear tokens from storage
  clearTokens();
};
